const getters = {
  brands: ({ brands }) => brands,

  brandsSimple: ({ brands }) => Object.keys(brands).map(key => {
    return {
      label: brands[key].name,
      value: brands[key].uuid
    }
  }),

  getById: ({ brands }) => (uuid) => {
    return brands[uuid]
  },

  active: ({ active }) => active,

  newBrand: ({ newBrand }) => newBrand
}

export default getters
